:host {
  @include reset-host;
  @include center('flex', 'both');
  font-size: rem(24);
}
